export default "__VITE_ASSET__f837d49a__"